import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, Info } from "lucide-react";
import { cn } from "@/lib/utils";

const MAP = {
  optimal: { icon: CheckCircle2, cls: "bg-emerald-500/10 border-emerald-500/30 text-emerald-700 dark:text-emerald-400" },
  warning: { icon: AlertTriangle, cls: "bg-amber-500/10 border-amber-500/30 text-amber-700 dark:text-amber-400" },
  critical: { icon: XCircle, cls: "bg-rose-500/10 border-rose-500/30 text-rose-700 dark:text-rose-400" },
  neutral: { icon: Info, cls: "bg-indigo-500/10 border-indigo-500/30 text-indigo-700 dark:text-indigo-400" },
};

const RISK_TO_SEVERITY = { Low: "optimal", Medium: "warning", High: "critical", Critical: "critical" };

export function severityFromScore(score) {
  if (score >= 75) return "optimal";
  if (score >= 50) return "warning";
  return "critical";
}

export function StatusBadge({ severity = "neutral", label, className, testId }) {
  const conf = MAP[severity] || MAP.neutral;
  const Icon = conf.icon;
  return (
    <span
      data-testid={testId}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold", conf.cls, className)}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
      <span>{label}</span>
    </span>
  );
}

export function RiskBadge({ risk, testId }) {
  return <StatusBadge severity={RISK_TO_SEVERITY[risk] || "neutral"} label={risk} testId={testId} />;
}
